import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './../material/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HelperService } from './helper/helper.service';

// Components
import { AlertPopupComponent } from './components/alert-popup/alert-popup.component';
import { UnsupportedBrowserComponent } from './components/unsupported-browser/unsupported-browser.component';
import { HeaderComponent } from './components/header/header.component';
import { LoaderComponent } from './components/loader/loader.component';
import { DialogSpinnerComponent } from './components/dialog-spinner/dialog-spinner.component';

// Directives
import { RestrictDotInputDirective } from './directives/restrict-dot-input.directive';
import { DebounceClickDirective } from './directives/debounce-click/debounce-click.directive';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { OnlyNumberDirective } from './directives/only-numeric.directive';

@NgModule({
  declarations: [
    AlertPopupComponent,
    UnsupportedBrowserComponent,
    HeaderComponent,
    LoaderComponent,
    DialogSpinnerComponent,
    DebounceClickDirective,
    RestrictDotInputDirective,
    OnlyNumberDirective,
    ErrorMessageComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
  ],
  exports: [
    MaterialModule,
    FlexLayoutModule,
    AlertPopupComponent,
    FormsModule,
    ReactiveFormsModule,
    UnsupportedBrowserComponent,
    HeaderComponent,
    LoaderComponent,
    DialogSpinnerComponent,
    DebounceClickDirective,
    RestrictDotInputDirective,
    OnlyNumberDirective,
    ErrorMessageComponent
  ],
  providers: [HelperService],
})
export class SharedModule { }
